import { generatePath } from 'react-router-dom'
import { Workspace } from 'types'
import { Users, UsersFilled } from 'blaze-ui/icons'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { SHARED_WITH_ME_DOCS_PATH } from 'paths'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuSharedWithMeItem = ({ workspace, onPress }: Props) => (
  <NavMenuItem
    icon={Users}
    activeIcon={UsersFilled}
    to={generatePath(SHARED_WITH_ME_DOCS_PATH, { workspaceId: workspace.id })}
    onPress={onPress}
    label="Shared With Me"
  />
)

export { NavMenuSharedWithMeItem }
